import { useEffect, useState, useCallback } from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { date } from 'yup';
import { parse } from 'path';

import { translatePrice, checkInvalid, checkValidDate } from '@helpers/product';
import { getBackupImg } from '@helpers/dataExists';
import { Container, CheckboxInput } from '@components';
import tilestyles from '@components/ProductTileCustom/ProductTile.module.scss';
import { useUsedSelector } from '@stores/used/selectors';
import styles from './RecentlyAdded.module.scss';

const DynamicImage = dynamic(() => import('@components/DynamicImage'), {
  ssr: false
});

const RecentlyAdded = ({ data, componentIsAvailable, showTitle, componentTitle }) => {
  const router = useRouter();
  const { locale } = router;
  const [availableItems, setAvailableItems] = useState([]);
  let categories = useSelector(useUsedSelector);
  categories = Array.isArray(categories) ? categories : [];

  const children = Array.isArray(categories)
    ? categories
        .map((m) => ({
          ...m,
          products: m.products.map((mm) => ({ ...mm, categorySlug: m.handle }))
        }))
        .flatMap((m) => m.products)
        .map((m) => ({
          ...m,
          postDate: new Date(parseInt(/\(([^)]+)\)/.exec(m.postDate)[1]))
        }))
        .sort((a, b) => b.postDate - a.postDate)
        .filter((m) => {
          return !m.attachments?.includes('N/A') || !m.attachments?.includes('n/a') || !m.attachments?.includes('?');
        })
        .splice(0, 5)
    : [];

  useEffect(async () => {
    await getBackupImg();
  });

  useEffect(() => {
    filterValidChildren();
  }, [categories]);

  //This function find children which all dates are positive
  const filterValidChildren = useCallback(() => {
    if (children.length > 0) {
      let validItems = [];
      validItems = children?.filter((x) => {
        return checkValidDate(x.postDate, x.expiryDate, x.solddateon);
      });
      setAvailableItems(validItems);
    }
  }, [categories]);

  return (
    componentIsAvailable && (
      <section className={styles.Section}>
        <Container className={styles.Container}>
          {showTitle && (
            <h2
              className={styles.Title}
              dangerouslySetInnerHTML={{
                __html: locale=='fr'? 'R&eacute;cemment ajout&eacute;': componentTitle
              }}
            >
            </h2>
          )}
          {availableItems?.length > 0 && (
            <ul className={styles.List}>
              {(availableItems || []).map((m, index) => (
                <Link
                  href={`/products/used/search/${m.categoryId}/${m.usedID}`}
                  key={`product-${index}`}
                  prefetch={false}
                >
                  <a className={styles.Tile}>
                    <div className={styles.ImageContainer}>
                      <DynamicImage imgSrc={m.image} sizes={'640x360'} alt={m?.category} />
                    </div>
                    <div className={styles.Content}>
                      <div className={styles.Info}>
                        <h3 className={styles.Toptitle}>{`${checkInvalid(m.year)} ${m.make} ${m.model}`}</h3>
                        <ul className={styles.QuickFeatures}>
                          <span className={tilestyles.Product_tile_desc}>{locale=='fr'? 'Concessionnaire':'Dealer'}: {m.company}</span><br />
                          <span className={tilestyles.Product_tile_desc}>{locale=='fr'? 'CH':'HP'}: {m.power}</span><br />
                          <span className={tilestyles.Product_tile_desc}>{locale=='fr'? 'Heures':'Hours'}: {m.hours}</span><br />
                          {/*<li
                          dangerouslySetInnerHTML={{
                            __html: m.comments?.substr(0,100)+"..."
                          }}></li>*/}
                        </ul>
                        <div>{translatePrice(m.price, locale)}</div>
                      </div>
                      {/* <CheckboxInput
                        className={styles.Compare}
                        title="Compare"
                      /> */}
                    </div>
                  </a>
                </Link>
              ))}
            </ul>
          )}
        </Container>
      </section>
    )
  );
};

export default RecentlyAdded;
